import { Component, inject } from "@angular/core";
import { MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { ButtonCtaComponent } from "@components/button-cta/button-cta.component";
import { CsIconModule } from "@components/icon";

@Component({
  selector: "app-city-climate-info",
  imports: [CsIconModule, ButtonCtaComponent],
  templateUrl: "./city-climate-info.component.html",
})
export class CityClimateInfoComponent {
  private readonly bottomSheetRef: MatBottomSheetRef = inject(MatBottomSheetRef);

  close(): void {
    this.bottomSheetRef.dismiss();
  }

  getLocation(): void {
    this.bottomSheetRef.dismiss(true);
  }

  continue(): void {
    this.bottomSheetRef.dismiss(false);
  }
}
